__turbopack_context__.v({
  "banner": "_5tC-Pq_banner",
  "cardBox": "_5tC-Pq_cardBox",
});
